export default "__VITE_ASSET__DknEI1PD__"